import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {SrcMappingFee} from "../../../model/mapping/src-mapping-fee";
import {MappingSrcMappingFeeService} from "../../../services/mapping/mapping-src-mapping-fee.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-mapp-fee',
  templateUrl: './src-mapping-fee.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class SrcMappingFeeComponent extends CrudBaseComponent<SrcMappingFee> {

  //fields
  sources: FieldRecord<any>[];
  exchanges: FieldRecord<any>[];
  fees: FieldRecord<any>[];

  constructor(cdref: ChangeDetectorRef,
              crudService: MappingSrcMappingFeeService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = crudService;
    this.newRecord = new SrcMappingFee();
    this.newRecord.id = -1;
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.id = -1;
      this.formRecord.sourceExecutionFee = undefined;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'sourceCode',
        width: 130
      },
      {
        field: 'crystalExchangeCode',
        width: 130,
        icon: (record: any) => {
          const exchField = this.exchanges ? this.exchanges.find(field => field.value
            && field.value.code === record.crystalExchangeCode) : undefined;
          if (exchField && exchField.value) {
            return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          } else {
            return 'fas fa-globe-europe';
          }
        }
      },
      {
        field: 'crystalExecutionFee',
        width: 130
      },
      {
        field: 'sourceExecutionFee',
        width: 130
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'sourceCode',
            required: true,
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.sources,
          },
          {
            field: 'crystalExchangeCode',
            required: true,
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.exchanges,
            icon: (ig: any) => {
              const exchField = this.exchanges ? this.exchanges.find(field => field.value && field.value.code === ig) : undefined;
              if (exchField && exchField.value) {
                return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              } else {
                return 'fas fa-globe-europe';
              }
            }
          },
          {
            field: 'crystalExecutionFee',
            required: true,
            filter: true,
            column: 3,
            type: TYPE.AUTOCOMPLETE,
            options: () => this.fees,
          },
          {
            field: 'sourceExecutionFee',
            required: true,
            column: 3,
            type: TYPE.TEXT
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.commonFieldService.getSources(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.sources = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 3;
    });

    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 3;
    });

    this.commonFieldService.getFees(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.fees = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 3;
    });

  }

  onFormShow() {
  }
}
